var React = require('react');

function Affiliate (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2212_6941)","key":0},[React.createElement("rect",{"width":"36","height":"36","fill":"white","key":0}),React.createElement("circle",{"cx":"12","cy":"24","r":"12","fill":"#5A54EC","key":1}),React.createElement("circle",{"cx":"24","cy":"12","r":"12","fill":"#B1AEF5","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 12C18.6274 12 24 17.3726 24 24C17.3726 24 12 18.6274 12 12Z","fill":"white","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2212_6941"},React.createElement("rect",{"width":"36","height":"36","fill":"white"})))]);
}

Affiliate.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Affiliate;

Affiliate.default = Affiliate;
